/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @next/next/no-img-element */

// const redis = new Redis({
//   url: process.env.UPSTASH_REDIS_REST_URL,
//   token: process.env.UPSTASH_REDIS_REST_TOKEN,
// });
import { useStyles } from "./styles";
import "./override.css";
import { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";
import SearchBar from "../../Common/SearchBar";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Link,
  Box,
  Stack,
  Grid,
  Button,
  Typography,
} from "@mui/material";
import CustomPagination from "../../Common/Pagination";
import CustomTabs from "../../Common/CustomTabs";
import { GetFileLists, DeleteFileEntry } from "./UploadAndShareAPICalls";
import { IRequestBody } from "../../Constants/interfaces";
import api_endpoints, { base_url } from "../../Api/end_points";

export default function BuildHistory({ res = null }: any) {
  const location = useLocation();
  const classes = useStyles();
  const { type, fileUrl, ipaUrl } = location.state || {};
  const [totalpages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [activeTab, setActiveTab] = useState(0);
  const [fileList, setFileList] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string | null>("");

  useEffect(() => {
    const endPt = `${api_endpoints.builds}?pageNo=0&pageSize=10&sort=desc`;
    getUploadedFiles(endPt);
  }, []);

  const getUploadedFiles = async (endPoint: string) => {
    const apiData = {} as IRequestBody;
    apiData.domain = base_url;
    apiData.endPoint = endPoint;
    apiData.showLoader = true;

    await GetFileLists(
      apiData,
      getFileListSuccessCallback,
      getFileListErrorCallback
    );
  };

  const getFileListSuccessCallback = (response: any) => {
    setFileList(response.data.buildUploadDtoList);
    setTotalPages(response.data.totalPages);
    setPageNumber(response.data.pageNo + 1);
  };
  const getFileListErrorCallback = (error: any) => {
    console.log("Error creating file list entry:", error);
  };

  const onPageChange = (page: number) => {
    setPageNumber(page);
    const osType = activeTab === 1 ? "ANDROID" : activeTab === 2 ? "IOS" : "";
    const endPt = `${api_endpoints.builds}?pageNo=${
      page - 1
    }&pageSize=10&sort=desc&osType=${osType}`;
    getUploadedFiles(endPt);
    // Call API
  };

  const handleSearchValueChange = (newSearchValue: string) => {
    setSearchValue(newSearchValue);
    setPageNumber(0);
    setActiveTab(0);
    const endPt = `${api_endpoints.builds}?pageNo=0&pageSize=10&sort=desc&term=${newSearchValue}`;
    getUploadedFiles(endPt);
  };

  const onDeleteClicked = async (row: any) => {
    const apiData = {} as IRequestBody;
    apiData.domain = base_url;
    apiData.endPoint = `${api_endpoints.builds}/${row.id}`;
    apiData.showLoader = true;

    await DeleteFileEntry(
      apiData,
      deleteFileListSuccessCallback,
      deleteFileListErrorCallback
    );
  };
  const deleteFileListSuccessCallback = (response: any) => {
    const endPt = `${api_endpoints.builds}?pageNo=0&pageSize=10&sort=desc`;
    getUploadedFiles(endPt);
  };
  const deleteFileListErrorCallback = (error: any) => {
    console.log("Error deleting file entry:", error);
  };

  const formatDateToIST = (inputDateStr: any) => {
    const [datePart, timePart] = inputDateStr.split(" ");
    const [day, month, year] = datePart.split("/");
    const utcFormatted = `${year}-${month}-${day}T${timePart}Z`; // Z = UTC
    const istDate = new Date(utcFormatted); // Add 5 hours 30 minutes for IST
    const dd = String(istDate.getDate()).padStart(2, "0");
    const mm = String(istDate.getMonth() + 1).padStart(2, "0");
    const yyyy = istDate.getFullYear();

    let hours = istDate.getHours();
    const minutes = String(istDate.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const hh = String(hours).padStart(2, "0");

    return `${dd}-${mm}-${yyyy} ${hh}:${minutes} ${ampm}`;
  };

  const renderTable = () => {
    return (
      <>
        <div>
          <TableContainer component={Paper} className="historyContainer">
            <Table>
              <TableHead sx={{ backgroundColor: "#f8f9fb" }}>
                <TableRow>
                  <TableCell sx={{ width: "100px" }}>
                    <strong>Date</strong>
                  </TableCell>
                  <TableCell sx={{ width: "480px" }}>
                    <strong>File URL</strong>
                  </TableCell>
                  <TableCell sx={{ width: "80px" }}>
                    <strong>Version</strong>
                  </TableCell>
                  <TableCell sx={{ width: "200px" }}>
                    <strong>User Name</strong>
                  </TableCell>
                  <TableCell sx={{ width: "220px" }}>
                    <strong>Comments</strong>
                  </TableCell>
                  <TableCell sx={{ width: "100px" }}>
                    <strong>OS</strong>
                  </TableCell>
                  <TableCell sx={{ width: "100px" }}>
                    <strong>Environment</strong>
                  </TableCell>

                  <TableCell sx={{ width: "120px" }}>
                    <strong>Barcode</strong>
                  </TableCell>
                  <TableCell sx={{ width: "100px" }}>
                    <strong></strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fileList.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>
                      {formatDateToIST(row.lastUpdatedDate)}
                    </TableCell>
                    <TableCell>
                      {row.eligibleForDelete ? (
                        "The APK/ IPA has been archieved, please contact BE team to fetch the file."
                      ) : (
                        <Link href={row.fileUrl} target="_blank" rel="noopener">
                          {row.fileUrl}
                        </Link>
                      )}
                    </TableCell>
                    <TableCell>{row.version}</TableCell>
                    <TableCell>{row.userName}</TableCell>
                    <TableCell>{row.comments}</TableCell>
                    <TableCell>{row.osType}</TableCell>
                    <TableCell>{row.environment}</TableCell>
                    <TableCell sx={{ width: "100px" }}>
                      <img
                        src={`https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
                          row.fileUrl
                        )}&size=100x100`}
                        alt="Scan QR Code"
                        className="qr-code"
                      />
                    </TableCell>
                    <TableCell sx={{ width: "100px" }}>
                      <Button
                        className={classes.deleteButtonHelper}
                        variant="text"
                        color="error"
                        onClick={() => onDeleteClicked(row)}
                      >
                        <Typography variant="subtitle2">Delete</Typography>
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Grid
            className={classes.gridStyle}
            item
            xs={4}
            key={"pagination" + totalpages}
          >
            {totalpages > 1 ? (
              <div
                style={{ margin: "auto" }}
                className={classes.paginationHelper}
              >
                <CustomPagination
                  pageNumber={pageNumber}
                  onChangePageNumber={onPageChange}
                  totalPages={totalpages}
                />
              </div>
            ) : null}
          </Grid>
        </div>
      </>
    );
  };
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    setPageNumber(1);
    switch (newValue) {
      case 0:
        getUploadedFiles(
          `${api_endpoints.builds}?pageNo=0&pageSize=10&sort=desc`
        );
        break;
      case 1:
        getUploadedFiles(
          `${api_endpoints.builds}?osType=ANDROID&pageNo=0&pageSize=10&sort=desc`
        );
        break;
      case 2:
        getUploadedFiles(
          `${api_endpoints.builds}?osType=IOS&pageNo=0&pageSize=10&sort=desc`
        );
        break;
      default:
        getUploadedFiles(
          `${api_endpoints.builds}?pageNo=0&pageSize=10&sort=desc`
        );
        break;
    }
    // Call API
  };

  return (
    <>
      <div>
        <meta name="description" content="Build History" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </div>
      <div className={classes.uploadAndShareContainer}>
        <div className={classes.searchBoxHelper}>
          <SearchBar
            placeholderText="Search by Comments, UserName"
            searchValue={searchValue || ""}
            onSearchValueChange={handleSearchValueChange}
            onEnterClick={() => {}}
          />
        </div>
        <Box className={classes.customTabBtmBorder}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <CustomTabs
              value={activeTab}
              tabsList={["All", "Android", "iOS"]}
              onChange={handleTabChange}
            />
          </Stack>

          <div>{renderTable()}</div>
        </Box>
      </div>
    </>
  );
}
